import React from 'react';
import { useStringsContext } from '../../../../contexts/strings';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import SocialCommentSettings from './social-comment-settings';

interface Props {
  selectedAbbrv: string | null;
}

const SocialHeader = ({ selectedAbbrv }: Props) => {
  const { strings } = useStringsContext();

  return (
    <Grid container justifyContent="space-between">
      <Grid>
        <Typography variant="h6">{strings.social.commentsTitle}</Typography>
      </Grid>
      <Grid>
        <SocialCommentSettings selectedAbbrv={selectedAbbrv!} />
      </Grid>
    </Grid>
  );
};

export default SocialHeader;
